import { GameMode, ScoreData } from '../lib/types';

const SCORE_STORAGE_KEY = 'drop7_scores';

export const getScoreStorage = (): ScoreData => {
  const data = window.localStorage.getItem(SCORE_STORAGE_KEY);
  if (data) {
    return JSON.parse(data) as ScoreData;
  }
  return {
    [GameMode.Classic]: {
      best: 0,
      average: 0,
      count: 0,
    },
    [GameMode.Blitz]: {
      best: 0,
      average: 0,
      count: 0,
    },
    [GameMode.Sequence]: {
      best: 0,
      average: 0,
      count: 0,
    },
  };
};

export const setScoreStorage = (data: ScoreData | null) => {
  if (data) {
    window.localStorage.setItem(SCORE_STORAGE_KEY, JSON.stringify(data));
  } else {
    window.localStorage.removeItem(SCORE_STORAGE_KEY);
  }
};
